module.exports = __webpack_public_path__ + "img/ico_fuzhi_bzxq_hui.a109a503.png";